module.exports = __webpack_public_path__ + "img/img_QA 2@2x.f8d51db9.png";